/**
 * Valida si un valor es de tipo objeto.
 * @return {boolean} true | false
 */
export const isTypeObject = (xs) => typeof xs === 'object';

/**
 * Valida si un valor es un array.
 * @return {boolean} true | false
 */
export const isArray = (xs) => isTypeObject(xs) && xs.hasOwnProperty('length');

/**
 * Retorna true si un valor es null o undefined.
 * @return {boolean} true | false
 */
export const isNullOrUndefined = (value) => value === '' || value === null || value === undefined;

/**
 * Valida si un array tiene elementos.
 * @param {elements[]} xs
 * @return {boolean} true | false
 */
export const checkHasElements = (xs) => xs.length > 0;

/**
 * Retorna true si un conjuntos de valores es null o undefined.
 * @return {boolean} true | false
 */
export const isNullOrUndefinedItems = (values) => {
    const isEmpty = (currentValue) => currentValue === '' || currentValue === null || currentValue === undefined;
    return values.some(isEmpty);
};
